import { createAction } from 'Helpers';
import generalTypes from './types';

const generalActions = {
	initializeStart: createAction(generalTypes.INITIALIZE.START),
	initializeFinished: createAction(generalTypes.INITIALIZE.FINISH),

	startApiLoading: createAction(generalTypes.API_STATUS.LOADING.START),
	stopApiLoading: createAction(generalTypes.API_STATUS.LOADING.STOP),
};

export default generalActions;
